/* eslint-disable no-alert */
/* eslint-disable class-methods-use-this */
import decode from 'jwt-decode';
import store from 'store';
import auth0 from 'auth0-js';
import history from '../routes/history';
import { AUTH_CONFIG, META_DATA_PREFIX } from '../config/auth0';
import {
  LOCAL_STORAGE_AUTH_KEY,
  LOCAL_STORAGE_POST_LOGIN_REDIRECT_URL,
  REFRESH_TOKEN_WAIT_TIME,
  MENTAL_HEALTH_SCREENING_DONE_FLAG,
} from '../config/constants';
import { getPatienDetailAPICall } from '../api/patient';

export default class Auth {
  constructor() {
    this.auth0 = new auth0.WebAuth(AUTH_CONFIG);
    // {
    //   domain: AUTH_CONFIG.domain,
    //   clientID: AUTH_CONFIG.clientId,
    //   redirectUri: AUTH_CONFIG.redirectUri,
    //   responseType: 'token id_token',
    //   scope: 'openid'
    //   // sso: true
    // }

    this.login = this.login.bind(this);
    this.loginPhone = this.loginPhone.bind(this);
    this.logout = this.logout.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.loggedIn = this.loggedIn.bind(this);
    this.getLoginsCount = this.getLoginsCount.bind(this);
    this.getUserProfile = this.getUserProfile.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getPatientAuth0Id = this.getPatientAuth0Id.bind(this)
    // this.signUp = this.signUp.bind(this);
  }

  // signUp(payload, callback) {
  //   const authPayload = { ...payload, connection: 'AHPatients' };
  //   this.auth0.signup(authPayload, callback);
  // }

  // Submit phone number to begin Passwordless transaction
  // sendSMS (phoneNumber, callback) {
  //   this.auth0.passwordlessStart({
  //     connection: 'sms',
  //     send: 'code',
  //     phoneNumber: phoneNumber
  //   }, callback)
  // }

  // Submit the passcode to complete authentication
  // login (username, password, callback) {
  // login (phoneNumber, code, callback) {
  //   this.auth0.passwordlessVerify({
  //     connection: 'sms',
  //     phoneNumber: phoneNumber,
  //     verificationCode: code
  //   }, callback)
  // }

  loginPhone(username, password, callback) {
    this.auth0.login(
      {
        realm: AUTH_CONFIG.connection,
        username,
        password,
      },
      callback
    );
  }

  login(username, password, callback) {
    this.auth0.login(
      {
        realm: AUTH_CONFIG.connection,
        username,
        password,
      },
      callback
    );
  }

  loggedIn() {
    const expiresAt = store.get(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT);
    return new Date().getTime() < expiresAt;
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        store.remove(MENTAL_HEALTH_SCREENING_DONE_FLAG)
      } else if (err) {
        history.replace('/login');
        window.alert(`Error: ${err.error}. Check the console for further details.`);
      }
    });
  }

  updateUserAppMetadataInLocalStorage(currentProfileInStorage) {
    store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE, currentProfileInStorage);
  }

  setSession(authResult, skipRedirect = false) {
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
    store.set(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN, authResult.accessToken);
    store.set(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN, authResult.idToken);
    store.set(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT, expiresAt);
    this.auth0.client.userInfo(authResult.accessToken, async (err, user) => {
      if (!err) {
        // if (user) {
        //   Sentry.configureScope((scope) => {
        //     scope.setTag('user_email', user.email);
        //   });
        // }
        const sub = user.sub.split("|");
        const guid = sub[1]
        const { responseOk, responseJSON } = await getPatienDetailAPICall(guid);
        if (responseOk) {
          store.set(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE, responseJSON.data);
        }
        if (!skipRedirect) {
          const postLoginRedirectUrl = store.get(LOCAL_STORAGE_POST_LOGIN_REDIRECT_URL);
          if (postLoginRedirectUrl) {
            store.remove(LOCAL_STORAGE_POST_LOGIN_REDIRECT_URL);
            history.replace(postLoginRedirectUrl);
          } else {
            history.replace('/homepage');
          }
        }
      }
    });
  }

  logout() {
    // Clear access token and ID token from local storage
    // logger.logUserSignOut()
    store.remove(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE);
    store.remove(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN);
    store.remove(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN);
    store.remove(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT);
    store.remove(LOCAL_STORAGE_AUTH_KEY.DAILLY_CHECKIN_FORM);
    store.remove(LOCAL_STORAGE_AUTH_KEY.STATE);
    // navigate to the home route
    history.push('/login');
  }

  resetForm() {
    // Clear access token and ID token from local storage
    // logger.logUserSignOut()
    store.remove(LOCAL_STORAGE_AUTH_KEY.DAILLY_CHECKIN_FORM);
    store.remove(LOCAL_STORAGE_AUTH_KEY.COVID_SCREENING_FORM);
    store.remove(LOCAL_STORAGE_AUTH_KEY.MENTAL_HEALTH_FORM)
    // navigate to the home route
  }

  getAppMetaData() {
    const token = this.getAccessToken();
    const decoded = decode(token);
    return decoded
  }

  getUserProfile() {
    const profileValueFromStorage = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE);
    let profile;
    if (profileValueFromStorage !== 'undefined') {
      profile = profileValueFromStorage;
    }
    return profile;
  }

  isNotificationAllowed() {
    return false;
    // const profile = this.getProfile()
    // if (profile) {
    //   const { userSettings: { userType } } = profile
    //   return userType !== 'radiographer'
    // }
    // return false
  }

  getPatientName() {
    const profileValueFromStorage = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE);
    let profile;
    if (profileValueFromStorage !== 'undefined') {
      profile = profileValueFromStorage;
    }
    return profile.name;
  }

  getPatientAuth0Id () {
    const profileValueFromStorage = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE);
    let profile;
    if (profileValueFromStorage !== 'undefined') {
      profile = profileValueFromStorage;
    }
    return profile.auth0_guid;
  }

  getToken() {
    return store.get(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN);
  }

  getAccessToken() {
    return store.get(LOCAL_STORAGE_AUTH_KEY.ACCESS_TOKEN);
  }

  setToken(idToken) {
    store.set(LOCAL_STORAGE_AUTH_KEY.ID_TOKEN, idToken);
  }

  refreshToken() {
    this.auth0.checkSession({}, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult, true);
      } else if (err) {
        history.replace('/login');
        window.alert(`Error: ${err.error}. Check the console for further details.`);
      }
    });
  }

  isTokenNearingExpiration() {
    try {
      const token = this.getToken();
      const decoded = decode(token);
      const currentTimeInSeconds = Date.now() / 1000;
      const difference = decoded.exp - currentTimeInSeconds;
      return difference < REFRESH_TOKEN_WAIT_TIME;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);
      return decoded.exp < Date.now() / 1000;
    } catch (err) {
      console.error(err);
      return true;
    }
  }

  getLoginsCount() {
    const userProfile = this.getUserProfile();
    if (!userProfile) {
      return null;
    }
    const loginCounts = userProfile && userProfile[`${META_DATA_PREFIX}logins_count`];
    return loginCounts;
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = store.get(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT);
    return new Date().getTime() < expiresAt;
  }
}
